import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/charts/saved")({
  loader: () => ({ collection: "saved" as const }),
});
